export default __webpack_public_path__ + "static/media/Private-5g_Connectivity-at-Scale.f5251084.mp4";